'use client'

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useApi } from '@/providers/api-provider'

export function useNotifications(unreadOnly = false) {
  const api = useApi()
  return useQuery({
    queryKey: ['notifications', { unreadOnly }],
    queryFn: () => api.notifications.list(unreadOnly),
  })
}

export function useNotificationCount() {
  const api = useApi()
  return useQuery({
    queryKey: ['notifications', 'count'],
    queryFn: () => api.notifications.count(),
    refetchInterval: 30000,
  })
}

export function useMarkNotificationRead() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.notifications.markRead(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] })
    },
  })
}

export function useMarkAllNotificationsRead() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api.notifications.markAllRead(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] })
    },
  })
}
